export const LAST_ACTIVITY_KEY = "cloud4smart.lastActivity";
export const DEFAULT_AUTO_LOGOUT_MINUTES = 15;
export const AUTO_LOGOUT_OPTIONS = [5, 10, 15, 30, 60] as const;

export type AutoLogoutMinutes = (typeof AUTO_LOGOUT_OPTIONS)[number] | null;

export function normalizeAutoLogoutMinutes(value: unknown): AutoLogoutMinutes {
  if (value === null) return null;
  const numeric = Number(value);
  return AUTO_LOGOUT_OPTIONS.find((option) => option === numeric) ?? DEFAULT_AUTO_LOGOUT_MINUTES;
}

export function formatAutoLogoutRemaining(remainingMs: number): string {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1_000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return minutes + ":" + String(seconds).padStart(2, "0");
}
